module.exports = __webpack_public_path__ + "static/media/transfer-in.b20b63e5.webp";